import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/system';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#102a43',
    color: '#ffffff',
    borderBottom: 'none',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: '#20334a',
    borderColor: '#e5edf4',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8fbfd',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#ffffff',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function WinnersTable({winners, loading, season}) {


  return (
    <TableContainer sx={{ border: '1px solid #dce5ee', borderRadius: 2, overflowX: 'auto' }}>
      <Table sx={{ minWidth: 580 }} size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell>Position</StyledTableCell>
            <StyledTableCell align="left">Player</StyledTableCell>
            <StyledTableCell align="left">Yards/Pts</StyledTableCell>
            <StyledTableCell align="left">Team</StyledTableCell>
            {season && <StyledTableCell align="left">Week</StyledTableCell> }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            loading &&

            Array(4).fill(0).map((_, i) => 
            <StyledTableRow
            key={i}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <StyledTableCell component="th" scope="row">
            <Skeleton animation="wave" variant="rectangular"  />
            </StyledTableCell>
            <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            {season && <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell> }
          </StyledTableRow>
            
            )
            
          }

          {!loading && winners && winners.map((row) => (
            <StyledTableRow
              key={`${row.Position}-${row.Player}-${row.Team}-${row.Week || "current"}`}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <StyledTableCell component="th" scope="row">
                {row.Position}
              </StyledTableCell>
              <StyledTableCell align="left">{row.Player}</StyledTableCell>
              <StyledTableCell align="left">{row.Stat}</StyledTableCell>
              <StyledTableCell align="left">{row.Team}</StyledTableCell>
              {season && <StyledTableCell align="left">{row.Week}</StyledTableCell>}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
